import React from 'react';
import { observer } from 'mobx-react-lite';
import { LayoutEnum } from '@app/common';
import { SuccessAlert } from './success-alert';
import { ErrorAlert } from './error-alert';
import { WarningAlert } from './warning-alert';
import { useRootStore } from '../../../providers/root-store-provider';
import { AlertPlacementEnum } from '../../../models/enums/alert-placement-enum';

interface AlertsPropsInterface {
    email?: string;
}

export const Alerts: React.FC<AlertsPropsInterface> = observer(({ email }: AlertsPropsInterface) => {
    const { themeStore, alertStore } = useRootStore();
    const { layout, showHeaderBar } = themeStore;

    if (alertStore.alertPlacement !== AlertPlacementEnum.Default) {
        return null;
    }

    let topClass: string | undefined;

    if (layout === LayoutEnum.Horizontal) {
        topClass = showHeaderBar ? 'top-[calc(4rem+2rem)]' : 'top-small';
    }

    const topStyle =
        layout === LayoutEnum.Vertical
            ? {
                  top: showHeaderBar ? 'calc(4rem + 10rem)' : '10rem',
              }
            : undefined;

    return (
        <div
            className={['fixed left-1/2 z-[920] -translate-x-1/2', topClass].filter(Boolean).join(' ')}
            style={topStyle}
        >
            <SuccessAlert />
            <ErrorAlert email={email} />
            <WarningAlert />
        </div>
    );
});
